package ro.horatiu_udrea.resursedeblocat

import androidx.compose.foundation.Image
import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import resursedeblocat.composeapp.generated.resources.Res
import resursedeblocat.composeapp.generated.resources.brand_image

@Composable
fun BaseScreenLayout(
    scrollState: ScrollState = rememberScrollState(),
    showLogoOnSmallScreen: Boolean = false,
    footer: @Composable (ColumnScope.() -> Unit)? = null,
    content: @Composable ColumnScope.() -> Unit
) {
    BoxWithConstraints(
        modifier = Modifier.fillMaxSize().background(MaterialTheme.colorScheme.background),
        contentAlignment = Alignment.TopCenter
    ) {
        val isWide = maxWidth > 600.dp
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier
                .padding(8.dp)
                .widthIn(max = 800.dp)
                .verticalScroll(scrollState)
        ) {
            if (isWide || showLogoOnSmallScreen) {
                Spacer(modifier = Modifier.height(24.dp))
                Image(
                    painter = painterResource(Res.drawable.brand_image),
                    contentDescription = "Logo Brand",
                    modifier = Modifier.width(if (isWide) 400.dp else 300.dp),
                    contentScale = androidx.compose.ui.layout.ContentScale.Fit
                )
                Spacer(modifier = Modifier.height(24.dp))
            } else {
                Spacer(modifier = Modifier.height(12.dp))
            }
            Surface(
                modifier = Modifier.fillMaxWidth(),
                shadowElevation = 4.dp,
                color = Color.White,
                shape = MaterialTheme.shapes.large
            ) {
                Column(
                    modifier = Modifier.padding(12.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    content()
                }
            }
            if (footer != null) {
                footer()
            }
            Spacer(modifier = Modifier.height(32.dp))
        }
    }
}
